import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import "./Home.css";
import Home1 from "../../components/Hero1/Hero1";
import Home2 from "../../components/Hero2/Hero2";
import Services from "../../components/Service/Service";
import Accordion from "../../components/Accordion/Accordion";
import SliderHero from "../../components/SliderHero/SliderHero";
import Client from "../../components/Client/Client";
import Customer from "../../components/Customer/Customer";
import Contact from "../../components/Contact/Contact";
import AOS from "aos";

const Home = () => {
  AOS.init();
  return (
    <>
      <SliderHero />
      <section id="services">
        <Services />
      </section>
      <section>
        <Accordion />
      </section>
      <Client />
      <Customer />
      <Contact />
    </>
  );
};

export default Home;
